"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const environmentName_1 = __importDefault(require("./environmentName"));
const inferCookieFromHost = () => {
    return environmentName_1.default + 'Session';
};
exports.default = inferCookieFromHost();
//# sourceMappingURL=sessionCookieName.js.map